import type { TariffTypeVerification } from '@src/core/buyerApiClient';
import { RENDERABLE_VERIFICATION_TYPES } from '@src/domains/products/features/productAdder/types/tariffVerification';

export const filterRenderableVerifications = (verifications: TariffTypeVerification[]): TariffTypeVerification[] =>
  verifications.filter((v) =>
    RENDERABLE_VERIFICATION_TYPES.includes(v.tariffVerification.type as (typeof RENDERABLE_VERIFICATION_TYPES)[number]),
  );
